"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const Modal_1 = __importDefault(require("./Modal"));
const Button_1 = __importDefault(require("../Button/Button"));
const ConfirmationModal = (props) => {
    const { message, onConfirm, onCancel, actionRequired = false, confirmLabel = "Confirm", cancelLabel = "Cancel", centered = false } = props, rest = __rest(props, ["message", "onConfirm", "onCancel", "actionRequired", "confirmLabel", "cancelLabel", "centered"]);
    var isCentered = false;
    if (centered)
        isCentered = "centered";
    const body = react_1.default.createElement("p", null, message);
    const footer = (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Button_1.default, { onClick: onCancel, variant: "cancel", text: cancelLabel, size: "small", testid: props.testid ? "testCancelBtn" : "" }),
        react_1.default.createElement(Button_1.default, { onClick: onConfirm, variant: "success", text: confirmLabel, size: "small", testid: props.testid ? "testConfirmBtn" : "" })));
    return (react_1.default.createElement(Modal_1.default, Object.assign({ headerText: "Confirm" }, rest, { isShown: props.isShown, onClose: props.onClose, body: body, footer: footer, testid: props.testid, actionRequired: actionRequired, centered: centered })));
};
exports.default = ConfirmationModal;
